import styled from 'styled-components/macro';

import {
  primaryTypography,
  numbersTypography,
} from 'styles/global/typography/typography';
import modularScale from 'styles/helpers/modular-scale';

import Row from 'components/data-visualization/Table/Row';
import Cell from 'components/data-visualization/Table/Cell';
import { StyledChangeArrow } from 'components/base/ChangeArrow/ChangeArrow';
import { markers } from './Playlist.styles';

export const CellContent = styled('div')<any>`
  ${numbersTypography};
  font-size: 1em;
  transition: ${({ theme }): string =>
    `${theme.transitionDuration} ${theme.timingFunction} transform`};
  font-weight: normal;
  text-align: right;
  padding-right: ${({ withoutPadding }) =>
    withoutPadding ? '0' : '2em'} !important;
  ${({ isPositive, trend, theme }): string =>
    trend
      ? `color: ${isPositive ? theme.PositiveChange : theme.NegativeChange};`
      : ''}

  ${StyledChangeArrow} {
    span {
      margin-right: 0.5em;
    }
  }
`;

export const EntityMetaData = styled('div')`
  ${primaryTypography};
  transition: ${({ theme }): string =>
    `${theme.transitionDuration} ${theme.timingFunction} transform`};
  font-weight: normal;
`;

export const TableCell = styled(Cell)<any>`
  flex: 0 0 33.333%;
  display: block;
  padding: 0;
  ${({ textAlign }): string => (textAlign ? `text-align: ${textAlign};` : '')};

  > div {
    padding: ${({ theme }): string => theme.spacing.xsmall};
    padding-left: 0;
  }

  @media screen and (min-width: 35em) {
    flex: 0 0 25%;
  }

  @media screen and (min-width: 60em) {
    display: table-cell;
    padding: ${({ theme, paddingLeft }): string =>
      `${theme.spacing.small} ${theme.spacing.xsmall} ${theme.spacing.small} ${
        paddingLeft ? theme.spacing.small : '0'
      }`};
    ${({ width }): string => (width ? `width: ${width};` : '')}

    > div {
      padding: 0;
    }

    &:first-of-type {
      padding-top: 0.5em;
    }

    &:nth-of-type(2) {
      ${CellContent} {
        text-align: left;
      }
    }
  }

  ${markers};
`;

export const TableRow = styled(Row)`
  display: flex;
  flex-flow: row wrap;
  padding-bottom: ${({ theme }): string => theme.spacing.xsmall};
  border-bottom: 1px solid ${({ theme }): string => theme.Grey};

  td {
    padding-left: ${({ theme }): string => theme.spacing.small};
  }

  td:first-of-type {
    width: 1%;
    white-space: normal;
    padding-left: 0;
    padding-right: 0.7rem;
  }

  @media screen and (min-width: 60em) {
    display: table-row;
    padding-bottom: 0;
    border-bottom: 0;

    td {
      border-bottom: 1px solid ${({ theme }): string => theme.Grey};
    }
  }
`;

export const PlaylistTableRow = styled(TableRow)<any>`
  &:hover {
    ${({ isTopList }) =>
      isTopList ? 'background: white;' : 'cursor: pointer;'}
  }
`;

export const EntityTitle = styled('h3')`
  font-weight: 600;
  line-height: 1.2;
  margin: 0;
  font-size: ${modularScale(0)};
`;

export const EntityMeta = styled('p')`
  font-size: ${modularScale(-1)};
  font-weight: normal;
  line-height: 1.2;
  color: ${({ theme }): string => theme.CasperGrey};
  margin: 0.25em 0 0;
`;

export const DSPEntityMeta = styled(EntityMeta)`
  font-size: ${modularScale(-2)};
  text-align: center;
`;

export const ExpandedTableRow = styled(TableRow)`
  background-color: ${({ theme }): string => theme.Sand};
`;
